module.exports = __webpack_public_path__ + "images/category_lp/game_console/assessment_achievements/6_47b269a1b9ee2cade996926b68a43194.png";